import { mapState } from 'vuex'

/**
 * カテゴリごとの公開依頼最低価格計算Mixin
 * @type {import('vue').ComponentOptions }
 */
const CategoryLowestPriceMixin = {
  computed: {
    ...mapState('master', ['requestPrices'])
  },
  methods: {
    getCategoryLowestPrice(category) {
      // カテゴリ未選択時
      if (!category) {
        return Math.min(...this.requestPrices)
      }

      // カテゴリの最低価格以上の選択肢のみ抽出
      const filteredPrices = this.requestPrices.filter(price => price >= category.lowestPrice)

      if (!filteredPrices.length) {
        // カテゴリの最低価格以上の選択肢がないとき（投稿不能になるので設定ミス以外ない）
        return category.lowestPrice
      }

      // カテゴリの最低価格以上の最小の選択肢
      return Math.min(...filteredPrices)
    }
  }
}
export default CategoryLowestPriceMixin
